import { Component, HostListener, inject } from '@angular/core';
import { routes } from './utils/constants/routes';
import { Language, PagesV2Module } from '@schenck/rotec-components';
import { TranslateDirective, TranslateService } from '@ngx-translate/core';
import { AVAILABLE_LANGS, DEFAULT_LANG } from './utils/constants/languages.const';
import { AppHeaderComponent } from './components/app-header/app-header.component';
import { RouterLinkActive, RouterLink } from '@angular/router';
@Component({
  selector: 'am-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  imports: [AppHeaderComponent, PagesV2Module, RouterLinkActive, RouterLink, TranslateDirective],
})
export class AppComponent {
  private readonly translate = inject(TranslateService);

  public tenantsLink = routes.tenants.absoluteUrl;
  public usersLink = routes.users.absoluteUrl;
  public machinesLink = routes.machines.absoluteUrl;

  public isLoggedIn = false;

  public onLogin(isLoggedIn: boolean) {
    this.isLoggedIn = isLoggedIn;
  }

  @HostListener('window:storage', ['$event'])
  public onStorageChange({ key, newValue }: StorageEvent) {
    key === 'language' && this.setLanguage(newValue as Language);
  }

  constructor() {
    this.setLanguage(localStorage.getItem('language') as Language);
  }

  private setLanguage(lang: Language) {
    const useLang = AVAILABLE_LANGS.includes(lang) ? lang : DEFAULT_LANG;

    this.translate.addLangs(AVAILABLE_LANGS);
    this.translate.use(useLang);
    !lang && localStorage.setItem('language', useLang);
  }
}
